import React from "react";

const TINT = { stanley: "#f2c85b", brian: "#62a8e5", both: "#e4be65" };

export default function SubtitleRibbon({ line, index, total, onNext, canNext }) {
  if (!line) return null;
  const tint = TINT[line.pov] || "#e4be65";
  return (
    <div
      data-testid="spatial-subtitle-ribbon"
      className="hud-panel tab-rise"
      style={{
        maxWidth: 900,
        margin: "0 auto",
        padding: "18px 26px 20px",
        borderRadius: 4,
        pointerEvents: "auto",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 8 }}>
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            padding: "3px 12px",
            borderRadius: 999,
            border: `1px solid ${tint}66`,
            background: `${tint}18`,
            color: tint,
            fontSize: 11,
            letterSpacing: "0.14em",
            textTransform: "uppercase",
          }}
        >
          <span style={{ width: 6, height: 6, borderRadius: 999, background: tint }} />
          {line.speaker}
        </span>
        <span className="font-mono-tel" style={{ color: "#7e8594", fontSize: 11, letterSpacing: "0.1em" }}>
          {line.time_label}
        </span>
        <span className="font-mono-tel" style={{ marginLeft: "auto", color: "#5a606c", fontSize: 11 }}>
          {index + 1}/{total}
        </span>
      </div>
      <p
        data-testid="spatial-subtitle-text"
        className="font-serif-q"
        style={{
          margin: 0,
          color: "#e4be65",
          fontSize: "clamp(18px, 2.4vw, 27px)",
          lineHeight: 1.4,
          fontStyle: "italic",
          textShadow: "0 2px 20px rgba(0,0,0,0.7)",
        }}
      >
        “{line.text}”
      </p>
      <div style={{ marginTop: 12, display: "flex", justifyContent: "flex-end" }}>
        <button
          data-testid="subtitle-next-button"
          onClick={onNext}
          className="ghost-btn"
          style={{ padding: "7px 18px", borderRadius: 3, fontSize: 12, cursor: "pointer" }}
        >
          {canNext ? "Continue ›" : "Proceed ›"}
        </button>
      </div>
    </div>
  );
}
